import { render } from "./Register.vue?vue&type=template&id=d3f0ef5c&scoped=true"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"

import "./Register.vue?vue&type=style&index=0&id=d3f0ef5c&lang=css"
import "./Register.vue?vue&type=style&index=1&id=d3f0ef5c&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d3f0ef5c"]])

export default __exports__